import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: "center"
    },
    welcomeText: {
        textAlign: "center"
    },
    loadingContainer: {
        alignItems: "center",
        justifyContent: "center",
        flex: 1
    },
    finishedContainer: {
        alignItems: "center",
        justifyContent: "center"
    },
    finishedText: {
        textAlign: "center"
    },
    tableInfoContainer: {
        alignItems: "center"
    },
    tableIconContainer: {
        alignItems: "center",
        justifyContent: "center",
        width: 150,
        height: 150,
        elevation: 2,
        shadowOffset: {
            width: 0,
            height: 2
        },
        shadowOpacity: 0.1,
        shadowRadius: 4
    },
    tableNoText: {
        position: "absolute",
        fontWeight: "bold",
        fontSize: 32
    }
});
export default stylesheet;
